var Navigation = function () {

    var $html,$body;
    var $navContainer, $heroNavigation, $heroNavigationLinks,
        $logoMenuHomepage, $homeContent, $heroVideo, $logoMenu, $menuButton, $searchButton;

    function init () {
        $html = $('html');
        $body = $('body');
        $navContainer = $('.site-navigation');
        $homeContent = $('.home-content');
        $heroVideo = $('.body video');
        $logoMenu = $('.logo-menu');
        $menuButton = $('.menu-button');
        $searchButton = $('#openSearch');
        $logoMenuHomepage = $('.logo-menu-homepage');
        $heroNavigation = $('.hero-navigation-background');
        $heroNavigationLinks = $('.hero-navigation-list li a');

        registerEvents();
        registerMediaQueries();
    }

    function toggleMenu () {
        let scrollTop = window.pageYOffset;
        requestAnimationFrame(function () {
            $html.toggleClass('navigation-active');
            $navContainer.removeClass('content-fade-out');
            if ($html.hasClass('navigation-active')) {
                $navContainer[0].scrollTop = 0;
                if (window.scrollBarWidth) {
                    $body.css({ 'padding-right': window.scrollBarWidth });
                    $logoMenu.css({ 'right': window.scrollBarWidth });
                    $menuButton.css({ 'transform': 'translateX(-' + window.scrollBarWidth + 'px)' });
                    // Prevent scroll jump
                    window.scrollTo(0, scrollTop);
                }
            } else {
                window.scrollBarWidth && $body.css({ 'padding-right': 0 });
                $logoMenu.css({ 'right': 0 });
                $menuButton.css({ 'transform': 'none' });
            }
        });
    }

    function contentFadeOut () {
        $navContainer.addClass('content-fade-out');
    }

    function isHomeContent () {
        return $homeContent.length;
    }

    function showProperLogo () {
        if (isHomeContent()) {
            var screenWidth = $(window).width();
            if (screenWidth >= 992) {
                $logoMenuHomepage.css('display', 'block');
            } else {
                $logoMenuHomepage.css('display', 'none');
            }
        }
    }

    function setMenuPosition () {
        requestAnimationFrame(() => {
            var homeContentTop = $homeContent[0].getBoundingClientRect().top;
            var heroVideoBottom = $heroVideo[0].getBoundingClientRect().bottom;

            if (heroVideoBottom <= 74) {
                if (!$heroNavigation.hasClass('hide')) {
                    $heroNavigation.addClass('hide');
                }
            } else {
                if ($heroNavigation.hasClass('hide')) {
                    $heroNavigation.removeClass('hide');
                }
            }

            if (-homeContentTop >= 0) {
                if (!$logoMenuHomepage.hasClass('fixed')) {
                    $logoMenuHomepage.addClass('fixed');
                }
            } else {
                if ($logoMenuHomepage.hasClass('fixed')) {
                    $logoMenuHomepage.removeClass('fixed');
                }
            }
        })
    }


    function registerEvents () {
        $body.on('click.toggleMenu', '.menu-button', toggleMenu);
        $body.on('click.closeForSearch', '#openSearch', contentFadeOut);
        $(window).on('resize', showProperLogo);
        if (isHomeContent()) {
            $(window).on('resize', setMenuPosition);
        }
    }

    function registerMediaQueries () {
        enquire.register('screen and (min-width: 768px)', {
            // SM and up
            match : function() {
                if (isHomeContent()) {
                    $(window).on('load', setMenuPosition);
                    $(window).on('scroll', setMenuPosition);
                }
                $(window).on('load', showProperLogo);
                $heroNavigationLinks.on('click', (event) => {
                    event.stopPropagation()
                });
            },
            // up to, excluding SM
            unmatch : function() {
                $(window).off('scroll', setMenuPosition);
                $heroNavigationLinks.off('click');
                $(window).off('load', setMenuPosition);
                $(window).off('scroll', setMenuPosition)
            }
        });
    }

    return {
        init: init
    }

}();
